import { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import { handleMicrosoftCallback } from '../../services/auth';
import { UserType } from '../../types/dataTypes';

const MicrosoftCallbackView = () => {
  const navigate = useNavigate();
  const { login } = useContext(UserContext);
  const [searchParams] = useSearchParams();

  const handleLoginSuccess = (res: UserType) => {
    login(res);
    const from = sessionStorage.getItem('msAuthRedirectFrom') || '/';
    sessionStorage.removeItem('msAuthRedirectFrom');
    sessionStorage.removeItem('msAuthSuccess');
    navigate(from);
  };

  const handleLoginError = (error: string) => {
    console.error('Microsoft login error:', error);
    sessionStorage.removeItem('msAuthRedirectFrom');
    sessionStorage.removeItem('msAuthSuccess');
    navigate('/login?error=' + encodeURIComponent(error));
  };

  useEffect(() => {
    if (searchParams.get('code') || searchParams.get('error')) {
      handleMicrosoftCallback(handleLoginSuccess, handleLoginError);
    }
  }, [searchParams]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <div>Processing Microsoft authentication...</div>
    </div>
  );
};

export default MicrosoftCallbackView;
